
module.exports = {
	Generator: require('./src/jsCalendar'),
	addLabels: require('./src/addLabels')
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/_js-calendar@1.2.3@js-calendar/index.js
// module id = 418
// module chunks = 0